(() => {
  const root = document.querySelector('[data-collection-page]');
  if (!root) return;

  const openButton = root.querySelector('[data-filter-open]');
  const closeButtons = root.querySelectorAll('[data-filter-close]');
  const panel = root.querySelector('[data-filter-panel]');
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const drawerSort = root.querySelector('#CollectionDrawerSort');
  const desktopSortHidden = root.querySelector('.collection-premium__desktop-sort-hidden');

  const syncSortFields = () => {
    if (drawerSort) drawerSort.disabled = desktopMedia.matches;
    if (desktopSortHidden) desktopSortHidden.disabled = !desktopMedia.matches;
  };

  const setFilterState = (open) => {
    const shouldOpen = open && !desktopMedia.matches;
    root.classList.toggle('is-filter-open', shouldOpen);
    document.body.style.overflow = shouldOpen ? 'hidden' : '';
    if (openButton) openButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', shouldOpen ? 'false' : desktopMedia.matches ? 'false' : 'true');
  };

  if (openButton) openButton.addEventListener('click', () => setFilterState(true));
  closeButtons.forEach((button) => button.addEventListener('click', () => setFilterState(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-filter-open')) setFilterState(false);
  });

  desktopMedia.addEventListener?.('change', () => {
    setFilterState(false);
    syncSortFields();
  });

  syncSortFields();
  if (panel && !desktopMedia.matches) panel.setAttribute('aria-hidden', 'true');

  const introShell = root.querySelector('[data-collection-intro-shell]');
  const intro = root.querySelector('[data-collection-intro]');
  const readMore = root.querySelector('[data-collection-read-more]');

  if (introShell && intro && readMore) {
    const updateReadMoreVisibility = () => {
      if (introShell.classList.contains('is-expanded')) return;
      const isOverflowing = intro.scrollHeight > intro.clientHeight + 2;
      readMore.hidden = !isOverflowing;
    };

    readMore.addEventListener('click', () => {
      const expanded = introShell.classList.toggle('is-expanded');
      readMore.textContent = expanded ? 'Read Less' : 'Read More';
      readMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      readMore.hidden = false;
    });

    requestAnimationFrame(updateReadMoreVisibility);
    window.addEventListener('resize', updateReadMoreVisibility, { passive: true });
  }

  const grid = root.querySelector('[data-product-grid]');
  const gridButtons = root.querySelectorAll('[data-grid-choice]');
  if (grid && gridButtons.length) {
    const storageKey = 'ethnicwish-collection-grid';
    const defaultGrid = grid.dataset.defaultGrid || '3';

    const applyGrid = (columns, remember = false) => {
      if (columns !== '3' && columns !== '4') return;
      grid.classList.remove('collection-premium__grid--3', 'collection-premium__grid--4');
      grid.classList.add(`collection-premium__grid--${columns}`);
      gridButtons.forEach((button) => {
        const active = button.dataset.gridChoice === columns;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (remember) {
        try { localStorage.setItem(storageKey, columns); } catch (_) {}
      }
    };

    let savedGrid = null;
    try { savedGrid = localStorage.getItem(storageKey); } catch (_) {}
    applyGrid(savedGrid || defaultGrid);

    gridButtons.forEach((button) => {
      button.addEventListener('click', () => applyGrid(button.dataset.gridChoice, true));
    });
  }
})();
